import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { usePageTitle } from '../layouts/PageTitleContext';
import useBreadcrumbSetup from '../components/useBreadcrumbSetup';
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faTachometerAlt, faCircleInfo, faCapsules, faCheck, faCheckCircle} from '@fortawesome/free-solid-svg-icons';
import Field from '../components/Form/Fields/Field';
import InputText from '../components/Form/Fields/InputText';
import ButtonContainer from '../components/Container/ButtonContainer';
import NavTab from '../components/NavTab/NavTab';
import SettingSection from '../components/Setting/SettingSection';
import systemConfig from '../config/systemConfig';
import Form from '../components/Form/Form';
import { toast } from 'react-toastify';
import { useAuth } from '../context/AuthProvider';
import InlineLoader from '../components/Loader/InlineLoader';
import { useTranslation } from 'react-i18next';
import { API_BASE_URL } from '../api';

const Settings = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const { setTitle, setTitleIcon } = usePageTitle();
  const { settings, reloadSettings, hasRight } = useAuth();
  const canEdit = hasRight('SETTINGS_EDIT');

  useEffect(() => {
  	setTitle(`${t('Settings')}<span style="display:block;font-size:11px;font-weight:400;color:#9ca3af;margin-top:5px;">Paramètres généraux de la pharmacie</span>`);
    document.title = t('Settings');
    setTitleIcon('ti-settings');
    return () => setTitleIcon(null);
  }, [t]);
  useBreadcrumbSetup([
    { label: t("Settings") },
  ]);

  const handleSubmit = (data) => {
    setLoading(true);
    const url = `${API_BASE_URL}/api/v1/setting/save`;

    axios.put(url, data, {withCredentials: true})
      .then(() => {
        toast.success('Configuration Saved Successfully !');
        reloadSettings();
      })
      .catch((error) => {
        console.error('Error saving configuration:', error);
      }).finally(() => {
        setLoading(false);
      });
  };

  const buttons = canEdit
    ? [{ label: 'Enregistrer', icon: faCheckCircle, className: 'sub-confirm-btn', form: 'updateSettingsForm', isLoading: loading }]
    : [];


  const menuItems = systemConfig.map(section => ({
	  id: section.id,
	  icon: section.icon || faCircleInfo,
	  label: section.label,
	  description: section.description,
	  component: <SettingSection section={section} systemConfig={systemConfig} />,
	}));

  const defaultValues = (() => {
    const defaults = {};
    const extractDefaults = (sectionId, groups) => {
      (groups || []).forEach(group => {
        (group.fields || []).forEach(field => {
          if (field.default !== undefined) {
            defaults[`${sectionId}_${group.id}_${field.id}`] = field.default;
          }
        });
        extractDefaults(sectionId, group.groups);
      });
    };
    systemConfig.forEach(section => extractDefaults(section.id, section.groups));
    return { ...defaults, ...settings };
  })();

  return (
    <div className="page-content">
      <Form id="updateSettingsForm" onSubmit={handleSubmit} defaultValues={defaultValues}>
        <NavTab menuItems={menuItems} className="navtab--settings" />
      </Form>

      <ButtonContainer buttons={buttons} />
    </div>
  );
};

export default Settings;
